export const SCREEN_FILTER_URL_PARAM = 'f'
